/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function debounce(func, wait) {
//     let timeout;
//     return function(...args) {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => func.apply(this, args), wait);
//     };
// }

// function createQuickAdd(elementSelector, variantId) {
//     const element = document.querySelector(elementSelector);
//     let count = 0; // Initialize the integer

//     if (!element) return;

//     function onFirstAdd() {
//         element.classList.add("is-visible");
//         element.style.transform = "scaleX(0.4)";
//     }

//     function onAdd(event) {
//         count++; // Increase the integer
//         console.log('Count after add:', count); // Log the count
//         debouncedUpdateCart(variantId, count);
//     }

//     function onRemove(event) {
//         if (event.propertyName === "transform" && element.classList.contains("is-finished")) {
//         count--; // Decrease the integer
//         console.log('Count after remove:', count); // Log the count
//         debouncedUpdateCart(variantId, count);
//         }
//     }

//     function _updateCart(id, quant) {
//         fetch(`${window.routes.cartUrl}/change.js`, {
//             body: JSON.stringify({ updates: { [id]: quant } }),
//             credentials: "same-origin",
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 "X-Requested-With": "XMLHttpRequest"
//                 // This is needed as currently there is a bug in Shopify that assumes this header
//             }
//         });
//     }

//     const debouncedUpdateCart = debounce(_updateCart, 300); // 300ms debounce

//     document.addEventListener("quickadd:show", onFirstAdd);
//     document.addEventListener("quickadd:add", onAdd);
//     document.addEventListener("quickadd:remove", onRemove);

//     element.addEventListener('click', (event) => {
//         if (event.target.matches('[data-action="increase-quantity2"]')) {
//           onAdd(event);
//         }
//     });
// }

// const buttons = document.querySelectorAll(".quickadd-button");
// for (const button of buttons) {
//     const variantId = button.getAttribute('data-variant-id');
//     createQuickAdd(`.quickadd-button[data-variant-id="${variantId}"]`, variantId);
// }

window.customer = window.customer || { slowClick: 0 };

class QuickBuy {
	constructor() {
		const amount = 0;
		this.initQty();
		this.initQtyInput();
		this.addingDisplay = document.querySelector(".addingtocartshow");
		this.initializeCartQuantities(); // Add this line
	}

	async initializeCartQuantities() {
		try {
			const response = await fetch(`${window.routes.cartUrl}.js`);
			const cart = await response.json();

			cart.items.forEach((item) => {
				const quantityInput = document.querySelector(
					`.quickbuy .quantity[data-id="${item.variant_id}"]`,
				);

				if (quantityInput.value > 0) {
					quantityInput?.parentElement?.setAttribute(
						"class",
						"quickbuy active",
					);
				}

				// this.amount = quantityInput;

				// const minusButton =
				// 	quantityInput?.parentElement?.querySelector(".minus");

				// if (minusButton) {
				// 	console.log(this.amount);
				// 	minusButton.setAttribute(
				// 		"data-quantity-visible",
				// 		quantityInput.value > 0,
				// 	);
				// }
			});
		} catch (error) {
			console.error("Error fetching cart:", error);
		}
	}

	initQty() {
		document
			.querySelectorAll('.adjust:not([data-listener="true"])')
			.forEach((adjustButton) => {
				let timeout;
				adjustButton.setAttribute("data-listener", "true");
				const isPlusButton = adjustButton.classList.contains("plus");

				adjustButton.addEventListener("click", () => {
					const updateValue = Number(adjustButton.getAttribute("data-update"));
					const quantityInput = adjustButton
						.closest(".quickbuy")
						.querySelector(".quantity");

					if (
						Number(quantityInput.value) ==
							quantityInput.getAttribute("data-max") &&
						updateValue == 1
					) {
						return true;
					}

					quantityInput.value = Number(quantityInput.value) + updateValue;
					if (Number(quantityInput.value) < 0) {
						quantityInput.value = 0;
					}

					this.qtyState(
						adjustButton.closest(".quickbuy"),
						Number(quantityInput.value),
					);

					const updateCart = () => {
						timeout = window.setTimeout(() => {
							if (window.customer.slowClick == 1) {
								document
									.querySelectorAll(".quickbuy")
									.forEach((quickbuyElement) => {
										quickbuyElement.classList.add("disabled");
									});
								this.addingDisplay.style.display = "block";
							}

							if (quantityInput.dataset.adjust === "cart") {
								document
									.querySelector(".cart-drawer--loading")
									.classList.add("active");
							}

							this.createFormData(
								quantityInput.dataset.id,
								Number(quantityInput.value),
								quantityInput.dataset.type,
								quantityInput.dataset.key,
								quantityInput.dataset.adjust,
							);
						}, 400);
					};

					if (
						isPlusButton &&
						Number(quantityInput.value) + updateValue >
							Number(quantityInput.getAttribute("data-max"))
					) {
						adjustButton.closest(".quickbuy").classList.add("max");
					} else {
						adjustButton.closest(".quickbuy").classList.remove("max");
					}

					clearTimeout(timeout);
					updateCart();
				});
			});
	}

	async createFormData(variantId, quantity, type, key, adjust) {
		let formData = {};
		let totalQuantity = 0;

		if (type === "generic") {
			formData = { updates: { [variantId]: quantity } };
			totalQuantity = quantity;
		} else if (type === "deal") {
			try {
				const cartResponse = await fetch("/cart.js");
				const cartData = await cartResponse.json();
				let updates = {};
				let itemFound = false;
				let itemUpdated = false;

				if (adjust === "cart") {
					cartData.items?.forEach((item) => {
						if (item.variant_id === Number(variantId) && item.key !== key) {
							totalQuantity += item.quantity;
						}
					});
				}

				totalQuantity += quantity;

				cartData.items?.forEach((item) => {
					if (item.variant_id === Number(variantId)) {
						itemUpdated = true;
						if (itemFound) {
							updates[item.key] = 0;
						} else {
							updates[item.key] = totalQuantity;
							itemFound = true;
						}
					}
				});

				if (!itemUpdated) {
					updates = { [variantId]: quantity };
				}

				formData = { updates: updates };
			} catch (error) {
				console.log("error", error);
			}
		}

		this.updateLineItem(formData, adjust);
		this.variantUpdates(totalQuantity, variantId);
	}

	async updateLineItem(formData, adjust = "") {
		try {
			const response = await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(formData),
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const responseData = await response.json();

			if (window.customer.slowClick == 1) {
				document.querySelectorAll(".quickbuy").forEach((quickbuyElement) => {
					quickbuyElement.classList.remove("disabled");
				});
				this.addingDisplay.style.display = "none";
			}

			document.documentElement.dispatchEvent(
				new CustomEvent("cart:refresh", {
					bubbles: true,
				}),
			);
		} catch (error) {
			console.error("Error:", error);
		}
	}

	variantUpdates(totalQuantity, variantId) {
		document
			.querySelectorAll(`[data-id="${variantId}"]`)
			.forEach((quantityInput) => {
				if (quantityInput.dataset.adjust !== "cart") {
					quantityInput.value = totalQuantity;
					if (totalQuantity === 0) {
						quantityInput.closest(".quickbuy").classList.remove("active");
					}

					const updateValue = Number(
						quantityInput.nextElementSibling.dataset.update,
					);
					const maxQuantity = quantityInput.dataset.max;

					if (Number(quantityInput.value) + updateValue > maxQuantity) {
						quantityInput.closest(".quickbuy").classList.add("max");
					} else {
						quantityInput.closest(".quickbuy").classList.remove("max");
					}
				}
			});
	}

	qtyState(quickbuyElement, quantity) {
		this.amount = quantity;
		if (quantity === 0) {
			quickbuyElement.classList.remove("active");
		} else {
			quickbuyElement.classList.add("active");
		}
	}

	initQtyInput() {
		document
			.querySelectorAll('input.quantity:not([data-listener="true"])')
			.forEach((quantityInput) => {
				let timeout;
				quantityInput.setAttribute("data-listener", "true");

				quantityInput.addEventListener("input", (event) => {
					const maxQuantity = Number(quantityInput.getAttribute("data-max"));
					const updateValue = Number(
						quantityInput.nextElementSibling.getAttribute("data-update"),
					);
					let inputValue = Number(event.target.value);

					if (Number(quantityInput.value) + updateValue > maxQuantity) {
						quantityInput.closest(".quickbuy").classList.add("max");
					} else {
						quantityInput.closest(".quickbuy").classList.remove("max");
					}

					if (Number(quantityInput.value) < 1) {
						this.handleZeroQty(quantityInput);
					}

					clearTimeout(timeout);

					(() => {
						timeout = window.setTimeout(() => {
							if (inputValue < 0) {
								inputValue = 0;
								quantityInput.value = 0;
							}

							if (inputValue > maxQuantity) {
								inputValue = maxQuantity;
								quantityInput.value = maxQuantity;
							}

							const remainder = inputValue % updateValue;
							if (remainder) {
								inputValue =
									inputValue + (updateValue - remainder) > maxQuantity
										? (inputValue -= remainder)
										: (inputValue += updateValue - remainder);
								quantityInput.value = inputValue;
							}

							this.createFormData(
								quantityInput.getAttribute("data-id"),
								inputValue,
								quantityInput.getAttribute("data-type"),
								quantityInput.getAttribute("data-key"),
								quantityInput.getAttribute("data-adjust"),
							);
						}, 800);
					})();
				});

				quantityInput.addEventListener("focusout", () => {
					if (!quantityInput.value || quantityInput.value === "0") {
						quantityInput.closest(".quickbuy").classList.remove("active");
					}
				});
			});
	}
}

function observeElementsWithRateLimit(selector, callback, delay = 300) {
	const elements = new Set(); // Store detected elements
	let timeoutId = null;

	const processElements = () => {
		if (elements.size > 0) {
			callback(Array.from(elements)); // Pass all new elements to the callback
			elements.clear(); // Clear the set for the next batch
		}
	};

	const observer = new MutationObserver(() => {
		document.querySelectorAll(selector).forEach((element) => {
			if (!element._observed) {
				element._observed = true; // Mark as observed
				elements.add(element); // Add to the set
			}
		});

		// Rate-limit with a debounce mechanism
		clearTimeout(timeoutId);
		timeoutId = setTimeout(processElements, delay);
	});

	observer.observe(document.body, { childList: true, subtree: true });
}

// Usage example
observeElementsWithRateLimit(
	".quickbuy",
	(newElements) => {
		console.log("Processing new elements batch:", newElements);
		const quickbuy = new QuickBuy();
	},
	500,
); // Adjust the delay (in ms) as needed

document.addEventListener("DOMContentLoaded", () => {
	const quickbuy = new QuickBuy();
});
